
/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        directions : [],
    },

    methods : {

    },

    getters : {

        getAllDirections(state) {

            return state.directions;

        },

        getDirectionById: (state) => (id) => {
            return state.directions.find(item => item.id == id)
        },


    },

    mutations: {

        setDirections(state, directions) {
            state.directions = directions;
        }
    
    },

    actions : {

        getDirections({dispatch, commit, rootState }) {

            return new Promise((resolve, reject) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                    axios.get('/directions')
                    .then(response => {
                        commit('setDirections', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;  
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через секунду
                                dispatch('getDirections');
                            }, t);
                        }
                        reject(error.response.status);
                    });
            });
        },

    }

}